// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-content[data-v-7ae8db70] .v-tabs .v-tabs-slider-wrapper{display:block!important}@media screen and (max-width:600px){.v-tabs[data-v-7ae8db70] .v-slide-group__next,.v-tabs[data-v-7ae8db70] .v-slide-group__prev{display:none!important}}", ""]);
// Exports
module.exports = exports;
